module.exports = __webpack_public_path__ + "static/media/education2.c15de947.png";